var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-invite-component", on: { keyup: _vm.keymap } },
    [
      _c("div", { staticClass: "room-invite" }, [
        _c(
          "div",
          { staticClass: "room-invite-header" },
          [
            _c("p", { staticClass: "room-invite-title" }, [
              _vm._v(_vm._s(_vm.$t("invite.title"))),
            ]),
            _c("GrmCloseBtn", {
              staticClass: "room-invite-close-button",
              on: { click: _vm.onClose },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "room-invite-body" }, [
          _c("p", { staticClass: "room-invite-description" }, [
            _vm._v(_vm._s(_vm.$t("invite.description"))),
          ]),
          _c("ul", { staticClass: "room-invite-list" }, [
            _c("li", { staticClass: "room-invite-item" }, [
              _c("button", {
                staticClass: "room-invite-button mail",
                on: { click: _vm.onToggleUsingEmail },
              }),
            ]),
            _c("li", { staticClass: "room-invite-item" }, [
              _c("button", {
                staticClass: "room-invite-button band",
                on: { click: _vm.inviteBand },
              }),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "room-invite-footer" },
          [
            _c("p", { staticClass: "room-invite-copy-url-description" }, [
              _vm._v(_vm._s(_vm.$t("invite.url.description"))),
            ]),
            _c(
              "VButton",
              {
                staticClass: "room-invite-copy-url-button",
                attrs: { focus: "" },
                on: { click: _vm.copyRoomUrlId },
              },
              [_vm._v(_vm._s(_vm.$t("invite.url.copy")))]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }